import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DefaultLayout from "./layouts/DefaultLayout";
import ProtectedLayout from "./layouts/ProtectedLayout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import GameHub from "./pages/GameHub";
import GamePage from "./pages/GamePage";
import PinBoard from "./pages/PinBoard"
import MentalStateGame from "./pages/MentalStateGame"
import RuleChaining from "./pages/RuleChaining"


function App() {
    return (
        <Routes>
            <Route element={<DefaultLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
            </Route>

            <Route element={<ProtectedLayout />}>
                <Route path="/gamehub" element={<GameHub />} />
                <Route path="/game" element={<GamePage />} />
                <Route path="/pinBoard" element={<PinBoard />} />
                <Route path="/mentalstate" element={<MentalStateGame />} />
                <Route path="/rulechaining" element={<RuleChaining />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
